/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthRefreshTokenBody
 */
export interface OAuthRefreshTokenBody {
    /**
     * The grant_type parameter must be set to "authorization_code" or "refresh_token".
     * @type {string}
     * @memberof OAuthRefreshTokenBody
     */
    grant_type: string;
    /**
     * The service will require the client authenticate itself when making the request for an access token. Typically services support client authentication via HTTP Basic Auth with the client’s client_id and client_secret. However, some services support authentication by accepting the client_id and client_secret as POST body parameters. Check the service’s documentation to find out what the service expects, since the OAuth 2.0 spec leaves this decision up to the service.
     * @type {string}
     * @memberof OAuthRefreshTokenBody
     */
    client_id: string;
    /**
     * The service will require the client authenticate itself when making the request for an access token. Typically services support client authentication via HTTP Basic Auth with the client’s client_id and client_secret. However, some services support authentication by accepting the client_id and client_secret as POST body parameters. Check the service’s documentation to find out what the service expects, since the OAuth 2.0 spec leaves this decision up to the service.
     * @type {string}
     * @memberof OAuthRefreshTokenBody
     */
    client_secret: string;
    /**
     * This parameter is for the authorization code received from the authorization server which will be in the query string parameter “code” in this request.
     * @type {string}
     * @memberof OAuthRefreshTokenBody
     */
    code?: string;
    /**
     * The refresh token previously issued to the client.
     * @type {string}
     * @memberof OAuthRefreshTokenBody
     */
    refresh_token?: string;
    /**
     * If the redirect URL was included in the initial authorization request, it must be included in the token request as well, and must be identical. Some services support registering multiple redirect URLs, and some require the redirect URL to be specified on each request. Check the service’s documentation for the specifics.
     * @type {string}
     * @memberof OAuthRefreshTokenBody
     */
    redirect_uri: string;
}

/**
 * Check if a given object implements the OAuthRefreshTokenBody interface.
 */
export function instanceOfOAuthRefreshTokenBody(value: object): value is OAuthRefreshTokenBody {
    if (!('grant_type' in value) || value['grant_type'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    if (!('client_secret' in value) || value['client_secret'] === undefined) return false;
    if (!('redirect_uri' in value) || value['redirect_uri'] === undefined) return false;
    return true;
}

export function OAuthRefreshTokenBodyFromJSON(json: any): OAuthRefreshTokenBody {
    return OAuthRefreshTokenBodyFromJSONTyped(json, false);
}

export function OAuthRefreshTokenBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthRefreshTokenBody {
    if (json == null) {
        return json;
    }
    return {
        
        'grant_type': json['grant_type'],
        'client_id': json['client_id'],
        'client_secret': json['client_secret'],
        'code': json['code'] == null ? undefined : json['code'],
        'refresh_token': json['refresh_token'] == null ? undefined : json['refresh_token'],
        'redirect_uri': json['redirect_uri'],
    };
}

export function OAuthRefreshTokenBodyToJSON(json: any): OAuthRefreshTokenBody {
    return OAuthRefreshTokenBodyToJSONTyped(json, false);
}

export function OAuthRefreshTokenBodyToJSONTyped(value?: OAuthRefreshTokenBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grant_type': value['grant_type'],
        'client_id': value['client_id'],
        'client_secret': value['client_secret'],
        'code': value['code'],
        'refresh_token': value['refresh_token'],
        'redirect_uri': value['redirect_uri'],
    };
}

